import React from 'react';
import {Feedback} from '../../../../data/models/Feedback/Feedback';
import Tooltip from '../../../../uiToolkit/Tooltip';
import {Icon} from '../../../../uiToolkit/Icon/Icon';
import MicroreelCardOptions from '../../../Microreels/List/components/MicroreelCardOptions';
import {formatTimeAgo} from '../../../../utils/notificationTimeTextConvertor';
import {feedbackText} from '../../feedbackText';
import styles from './FeedbackCard.module.css';

interface Props {
  feedback: Feedback;
  canEdit: boolean;
  onOpen: (feedback: Feedback) => void;
  onDelete: (feedback: Feedback) => void;
}

const FeedbackCard = React.memo(
  ({feedback, canEdit, onOpen, onDelete}: Props) => {
    const timeAgo = formatTimeAgo(feedback.dateCreated);
    const options = [
      {label: feedbackText.open, onClick: () => onOpen(feedback)},
    ];
    if (canEdit) {
      options.push({
        label: feedbackText.delete,
        onClick: () => onDelete(feedback),
        danger: true,
      } as (typeof options)[number]);
    }

    return (
      <div className={styles.card} onClick={() => onOpen(feedback)}>
        <div className={styles.header}>
          <span className={styles.iconWrapper}>
            <Icon name="feedback-menu.svg" className={styles.icon} />
          </span>
          <Tooltip tooltipText={feedback.title}>
            <p className={styles.title}>{feedback.title}</p>
          </Tooltip>
          <div className={styles.options} onClick={ev => ev.stopPropagation()}>
            <MicroreelCardOptions options={options} />
          </div>
        </div>
        <p className={styles.question}>{feedback.question}</p>
        <div className={styles.metaRow}>
          <span className={styles.chip}>
            {feedbackText.showAfterChip(feedback.numberOfFinishedLessonTrigger)}
          </span>
          <span className={styles.chip}>
            {feedbackText.answersCount(feedback.answers.length)}
          </span>
          {timeAgo && (
            <span className={styles.date}>
              {feedbackText.createdAgo(timeAgo)}
            </span>
          )}
        </div>
      </div>
    );
  },
);

export default FeedbackCard;
